import {
  Typography,
  useMediaQuery,
} from "@braintrust/braintrust-ui-components";

type PaymentMethodMaskedIBANProps = {
  last4: string | null;
  country: string | null;
};

export const PaymentMethodMaskedIBAN = ({
  last4,
  country,
}: PaymentMethodMaskedIBANProps) => {
  const isSmall = useMediaQuery("sm");

  return (
    <Typography component="span" size={isSmall ? "small" : "medium"}>
      {country ?? "XX"}
      {isSmall ? (
        <>&nbsp;&bull; &bull; &bull; &bull;&nbsp;</>
      ) : (
        <>
          &nbsp;&nbsp;&bull; &bull; &bull; &bull;&nbsp;&nbsp; &bull; &bull;
          &bull; &bull;&nbsp;&nbsp; &bull; &bull; &bull; &bull;&nbsp;&nbsp;
        </>
      )}
      {last4}
    </Typography>
  );
};
